import { useState } from 'react';
import type { Conflict } from '@micplot/shared';

const KIND_LABEL: Record<Conflict['kind'], string> = {
  overlap: 'Double booking',
  changeover: 'Changeover too tight',
  unassigned: 'No free channel',
  'type-mismatch': 'Wrong mic type',
};

/**
 * Every conflict, not just the first. During a show the second problem matters
 * as much as the first, and a single-line summary hides how bad things are.
 */
export default function ConflictPanel({ conflicts }: { conflicts: Conflict[] }) {
  const [open, setOpen] = useState(false);
  if (conflicts.length === 0) return null;

  // Changeover and overlap are live-show problems; the rest are planning gaps.
  const urgent = conflicts.filter(c => c.kind === 'overlap' || c.kind === 'changeover');

  return (
    <div className={`banner ${urgent.length ? 'danger' : ''} conflict-panel`}>
      <button className="conflict-toggle" onClick={() => setOpen(v => !v)}
              aria-expanded={open}>
        <strong>
          {conflicts.length} issue{conflicts.length > 1 ? 's' : ''}
          {urgent.length > 0 && ` · ${urgent.length} need${urgent.length > 1 ? '' : 's'} attention`}
        </strong>
        <span className="muted">{open ? 'Hide' : 'Show all'}</span>
      </button>

      {open ? (
        <ul className="conflict-list">
          {conflicts.map((c, i) => (
            <li key={i}>
              <span className={`chip ${c.kind === 'overlap' || c.kind === 'changeover'
                ? 'chip-danger' : ''}`}>
                {KIND_LABEL[c.kind]}
              </span>
              <span>{c.message}</span>
            </li>
          ))}
        </ul>
      ) : (
        <span className="conflict-first">{conflicts[0]!.message}</span>
      )}
    </div>
  );
}
